window.UTILS = window.UTILS || { };
var ColorTestSwatches = function() {

  var $ = window.jQuery;

  console.log( "ColorTestSwatches" );

  $( ".colortestswatches .swatch" ).on( "click" , function() {
    $( ".colortestswatches .swatch" ).removeClass( "swatch--selected" );
    $( this ).addClass( "swatch--selected" );
    var i = $( this ).attr( "data-colorindex" );
    var root = document.documentElement;
    // var col = root.style.getPropertyValue(  );
    var col = getComputedStyle( root ).getPropertyValue( "--pink-" + i );
    root.style.setProperty( "--ac-pink", col );
    console.log( "click", i, col );
  } );

};
new ColorTestSwatches();